'use client';

import {useState} from 'react';

import {QueryRewardProgramResponse} from '@elys-network/elys-telescope/elys/commitment/query';

import {
  ElegibilityStatus,
  useAcceptAirdrop,
  // useClaimKol,
} from 'app/hooks/useElegibility';

import {Card, CardContent} from '../components/Card';
import {Description} from '../components/Description';
import Title from '../components/Title';
import Wrapper from '../components/Wrapper';
import {getBackgroundUrl, getTitle} from '../utils/utils';
import {Button} from 'app/shared/buttons/Button';
import {Icons} from 'app/constants/icons';
import {Info} from '../components/Info';

const getEligibilityStatus = (
  status?: ElegibilityStatus,
): 'elegible' | 'not-elegible' | 'period-over' | 'claimed' | 'not-started' => {
  switch (status) {
    case 1:
      return 'elegible';
    case 2:
      return 'claimed';
    case 3:
      return 'period-over';
    case 4:
      return 'not-started';
    default:
      return 'not-elegible';
  }
};

export default function Elegible({
  airdropStatus,
  airdropData,
  address,
  refetch,
}: {
  airdropStatus: ElegibilityStatus;
  airdropData: QueryRewardProgramResponse | undefined | null;
  address: string;
  total: number;
  elysTotal: number | undefined;
  refetch: () => void;
}) {
  const [airdropElegible] = useState(getEligibilityStatus(airdropStatus));
  const {mutateAsync: acceptAirdrop} = useAcceptAirdrop();
  const isAirdropElegible = airdropElegible !== 'not-elegible' && airdropElegible !== 'not-started' && airdropData;
  const [isLoading, setIsLoading] = useState(false);

  const handleAirdropClaim = async () => {
    try {
      setIsLoading(true);

      await acceptAirdrop(address);
      refetch();
    } catch (error) {
      console.error('Failed to process claim:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleKolClaim = async (refund: boolean) => {
  //   try {
  //     setIsLoading(true);

  //     await claimKol({address, refund});
  //   } catch (error) {
  //     console.error('Failed to process claim:', error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <Wrapper backgroundUrl={getBackgroundUrl(airdropElegible)}>
      <div className="z-10 flex flex-col items-center gap-4">
        {(airdropElegible === 'claimed' || airdropElegible === 'elegible') && (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src="/logos/3d-eden-coin.png"
            alt="elys logo as a 3d coin"
            className="mb-4"
            width={100}
            height={100}
          />
        )}
        <Title title={getTitle(airdropElegible)} className="mb-4" />
        <Description elegible={airdropElegible} className="mb-4" />

        {isAirdropElegible && (
          <Card>
            <div className="flex items-center justify-between gap-10 mobile:flex-col">
              <CardContent
                isEden
                variant="green"
                title="Your Allocation"
                value={+(airdropData?.amount || 0)}
              />

              {!airdropData.claimed && <div>
                <Button
                  disabled={isLoading || airdropElegible === 'claimed'}
                  className="rounded-lg px-3 py-3"
                  variant="primary-contained"
                  onClick={handleAirdropClaim}>
                  Claim Airdrop
                  <Icons.chevronRight className="h-4 w-4" />
                </Button>
              </div>}
            </div>
          </Card>
        )}

        {/* {isKolElegible && (
          <Card>
            <div className="flex justify-between gap-4 mobile:flex-col">
              {!!kolData?.elysAmount && (
                <CardContent
                  title="Key Opinion Leader"
                  value={+kolData.elysAmount}
                  variant={kolData.claimed ? 'green' : 'blue'}
                />
              )}
            </div>
          </Card>
        )} */}
        {/* {isKolElegible && !kolData?.claimed && !kolData?.refunded && (
          <div className="flex gap-4">
            <Button
              disabled
              // disabled={isLoading}
              className="rounded-lg px-4 py-2"
              variant="primary-contained"
              onClick={() => handleKolClaim(false)}>
              Claim
            </Button>
            <Button
              disabled
              // disabled={isLoading}
              className="rounded-lg px-4 py-2"
              variant="secondary-contained"
              onClick={() => handleKolClaim(true)}>
              Refund
            </Button>
          </div>
        )} */}
      </div>
      <Info elegible={airdropElegible} />
    </Wrapper>
  );
}
